<template>
  <div>
    <div class="greyDarken1--text subheading pb-2">
      {{ title }}
    </div>

    <v-tabs
      @change="onChangeTab"
      v-model="tab"
      color="grey lighten-4"
      grow
      height="40px"
    >
      <v-tab>Preview</v-tab>
      <v-tab>Source</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" fixed-tabs>
      <v-tab-item>
        <vue-editor
          name="Description"
          class="mt-2"
          :value="value"
          @input="$emit('input', $event)"
          :editor-toolbar="editorToolbar"
          useCustomImageHandler
          @image-added="handleImageAdded"
          :editorOptions="editorSettings"
          @text-change="handleTextChange"
          ref="vueeditor"
          placeholder="Type screening description..."
        ></vue-editor>
      </v-tab-item>
      <v-tab-item>
        <v-textarea
          class="mt-2"
          v-model="htmlContent"
          outline
          placeholder="Source code of editor appears here..."
          rows="10"
        ></v-textarea>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import { VueEditor, Quill } from "vue2-editor";
import { getAuthHash } from "@/api/_manager";
import { mapGetters } from "vuex";
import axios from "axios";
import ImageResize from "quill-image-resize-vue";
Quill.register("modules/imageResize", ImageResize);
import i18n from "@/i18n"

export default {
  props:{
    value:{},
    title:{
      type:String,
      default:i18n.t('screener.save.screening_description.label')
    }
  },
  name: "TextEditor",
  data() {
    return {
      editorToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        ["blockquote", "code-block", "image"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        ["video"],
        ["link"],
        ["clean"],
        [{ 'direction': 'rtl' }],
      ],
      editorSettings: {
        modules: {
          imageResize: {},
        },
      },
      tab: null,
      htmlContent: "",
    };
  },
  components: {
    VueEditor,
  },
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
    }),
  },
  created() {
    this.htmlContent = this.value;
  },
  watch: {
    htmlContent: function (newValue, oldValue) {
      if (newValue) {
        this.$emit("input", this.htmlContent);
      }
    },
  },
  methods: {
    onChangeTab(tab) {
      // can't update directly as vue editor count each input
      // as html element
      if (tab == 1) {
        this.htmlContent = this.value;
      }
      if (tab == 0) {
        this.$emit("input", this.htmlContent);
      }
    },
    handleImageAdded(file, Editor, cursorLocation) {
      const accessToken = JSON.stringify(getAuthHash());
      var formData = new FormData();
      formData.append("file", file);
      formData.append("collection", "public");
      this.$store.dispatch("app/showLoader");
      var _this = this;
      axios({
        url: `${this.DEFINES.BASE_API_URL}/member/company/${this.selected_company_id}/upload_desc_img`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: formData,
      })
        .then((result) => {
          let url = result.data.data.image_url;
          Editor.insertEmbed(cursorLocation, "image", url);
        })
        .catch((err) => {
          _this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        })
        .finally(() => {
          _this.$store.dispatch("app/hideLoader");
        });
    },

    handleTextChange(delta, _oldContents, _source) {
      for (var i = 0; i < delta.ops.length; i++) {
        if (delta.ops[i].hasOwnProperty("insert")) {
          if (delta.ops[i].insert === "\n") {
            // on enter replace <p><br></p>
            // to br as quill insert <p><br></p> on enter
            var regex = /<p><br><\/p>/g;
            var editorContent = this.$refs.vueeditor.quill
              .getHTML()
              .replace(regex, "<br>");

            this.$emit("input", editorContent);
          }
        }
      }
    },
  },
};
</script>
<style>
  .ql-snow .ql-tooltip{
    left: 40% !important;
    top: 0!important;
  }
</style>
